import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from 'components/Modal/style'
import StartupProjectList from './StartupProjectList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { createProjectFromStartupAction } from 'actions/projectActions'
import axios from 'axios'
import { currentUser } from 'helpers/globals'

function mapStateToProps({ ui, projects }) {
  return { modalContent: ui && ui.modal, projects }
}

class ApplicationSetupModal extends React.Component {
  state = { testing: false, siteAccess: null, dbAccess: null }

  componentWillReceiveProps = nextProps => {
    if (this.props.modalContent !== nextProps && nextProps.modalContent === 'ProjectLoadModal') this.testConnections()
  }

  testConnections = _ => {
    this.setState({ testing: true })

    axios.get(`${IPVM_URL}/${currentUser}`)
      .then(res =>
        this.setState({ siteAccess: res.status < 400 })
      )
      .catch(e =>
        this.setState({ siteAccess: false })
      )

    axios.get(CLOUDANT_URL)
      .then(res =>
        this.setState({ dbAccess: res.status < 400 })
      )
      .catch(e =>
        this.setState({ dbAccess: false })
      )
  }

  testingComplete = _ =>
    this.state.testing && this.state.siteAccess !== null && this.state.dbAccess !== null

  connectionFailed = _ =>
    this.state.testing && (this.state.siteAccess === false || this.state.dbAccess === false)

  renderResult = key => {
    const { state, props: { classes } } = this

    if (state[key] !== false) return null

    return (
      <div key={key} style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon='times' style={{ color: 'red', marginRight: '1rem', fontSize: '3rem' }} />
        <span>
          Cannot connect to { ' ' }
          { key === 'siteAccess' ? <a href={ IPVM_URL } target='_blank'>{ IPVM_URL }</a> : <a href={ CLOUDANT_URL } target='_blank'>{ CLOUDANT_URL }</a> }
          . Please unblock this URL.
        </span>
      </div>
    )
  }

  contentToRender = modal => {
    switch (modal) {
      case 'SetupProjectModal':
        return (
          <div>
            <div>
              <div style={{ marginBottom: '1rem' }}>This project cannot open as an error occured. Please restart your browser as it may clear the problem or <a href={`${IPVM_URL}/contact?subject='Project unable to load'`} target='_blank'>contact us for assistance.</a></div>
              {
                this.props.projects.length <= 1
                ? <div>In the meantime you can <a onClick={this.props.createProjectFromStartupAction}>create a new project</a>.</div>
                : <p>In the meantime, you can choose another project or <a onClick={this.props.createProjectFromStartupAction}>create a new one</a>.</p>
              }
            </div>
            <StartupProjectList />
          </div>
        )
      case 'LocalStorageUnavailable':
        return (
          <div>
            <p>Your browser cannot load the IPVM Designer / Calculator. There are two causes for this:</p>
            <ol>
              <li>The browser you are using is not supported. The supported browsers are the latest versions of Chrome, Edge, Firefox, and Safari.</li>
              <li>Cookies are disabled on a supported browser.</li>
            </ol>
          </div>
        )
      case 'ProjectLoadModal':
        return (
          <div style={{ marginBottom: '1rem' }}>
            The IPVM Designer / Calculator cannot open.
            { ['siteAccess', 'dbAccess'].map(key => this.renderResult(key)) }
            { this.testingComplete() &&
              <p style={{ marginTop: '1rem', marginBottom: '0rem' }}>
                <span>{ this.connectionFailed() ? 'If you still cannot connect or need help, ' : 'Please ' }</span>
                <a href={`${IPVM_URL}/contact?subject='Calculator unable to load'`} target='_blank'>contact us for assistance.</a>
              </p>
            }
          </div>
        )
      default:
        throw new Error('No modal match from ApplicationSetupModal')
    }
  }

  titleToRender = modal => {
    switch (modal) {
      case 'SetupProjectModal':
        return 'Projects'
      case 'LocalStorageUnavailable':
        return ''
      case 'ProjectLoadModal':
        return 'Error Loading Designer / Calculator'
      default:
        throw new Error('No title match from ApplicationSetupModal')
    }
  }

  render() {
    const { contentToRender, titleToRender, props: { modalContent, classes } } = this
    if (!modalContent) return null
    return (
      <div className={classes.modal}>
        <div className={classes.container} style={{ width: '600px' }}>
          <div className={classes.header}>
            <span className={classes.title}>{titleToRender(modalContent)}</span>
          </div>
          <div className={classes.body}>
            {contentToRender(modalContent)}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { createProjectFromStartupAction })(injectSheet(style)(ApplicationSetupModal))



// WEBPACK FOOTER //
// ./src/components/ApplicationSetupModal/index.js